export default __webpack_public_path__ + "static/media/Card Payment_Flatline.a8a70fae.svg";